"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconNameArray = exports.Icon = void 0;
var anvil_icons_1 = require("@servicetitan/anvil-icons");
Object.defineProperty(exports, "Icon", { enumerable: true, get: function () { return anvil_icons_1.Icon; } });
Object.defineProperty(exports, "IconNameArray", { enumerable: true, get: function () { return anvil_icons_1.IconNameArray; } });
//# sourceMappingURL=Icon.js.map